<template>
  <div class="rootDiv">
    <div>
      <div>
        <header class="mint-header is-fixed" style="border-bottom: 1px solid gainsboro;background: white;">
          <div style="width: 30rem;height: 32px;" class="mint-search searchstyle">
            <div class="mint-searchbar" style="padding: 0">
              <div class="mint-searchbar-inner">
                <i class="mintui mintui-search"/>
                <input type="search" placeholder="搜索" class="mint-searchbar-core" style="color: black" @focus="Onfocus"/>
                <a class="mint-searchbar-cancel" style="display: none;">取消</a>
              </div>
              <div class="mint-search-list" style="display: none;">
                <div class="mint-search-list-warp"/>
              </div>
            </div>
          </div>
        </header>
      </div>
      <div style="margin-top: 3rem">
        <Tabs>
          <Tab title="按省份" label="">
            <span>总计：{{ ProvinceCount }}个</span>
            <Cell :title="item.sXMC" v-for="item in ProvinceList" :key="item.sXMC" class="cellstyle"
                  v-on:click.native="GoProvince(item)"
                  :is-link="true">
              <img slot="icon" src="../../../assets/images/32/administration_icon.png" width="24" height="24" alt="">
              <div v-if="item.jCSL>0">
                <img src="../../../assets/images/16/warning.png" width="16" height="16" alt="" v-if="item.cWSL!==0">
                <span v-if="item.cWSL!==0">{{ item.cWSL }}</span>
                <img style="margin-left: 10px" src="../../../assets/images/16/airport_count.png" width="16"
                     height="16"
                     alt="">
                <span>{{ item.jCSL }}</span>
              </div>
            </Cell>
          </Tab>
          <Tab title="按等级" label="">
            <span>总计：{{ LevelCount }}个</span>
            <Cell :title="item.sXMC+' 机场'" v-for="item in LevelList" :key="item.sXMC" class="cellstyle"
                  v-on:click.native="GoLevel(item)" :is-link="true">
              <img slot="icon" src="../../../assets/images/32/administration_icon.png" width="24" height="24" alt="">
              <div v-if="item.jCSL>0">
                <img src="../../../assets/images/16/warning.png" width="16" height="16" alt="" v-if="item.cWSL!==0">
                <span v-if="item.cWSL!==0">{{ item.cWSL }}</span>
                <img style="margin-left: 10px" src="../../../assets/images/16/airport_count.png" width="16" height="16"
                     alt="">
                <span>{{ item.jCSL }}</span>
              </div>
            </Cell>
          </Tab>
          <Tab title="按地区" label="">
            <span>总计：{{ RegionCount }}个</span>
            <Cell :title="item.sXMC" v-for="item in RegionList" :key="item.sXMC" class="cellstyle"
                  v-on:click.native="GoRegion(item)" :is-link="true">
              <img slot="icon" src="../../../assets/images/32/administration_icon.png" width="24" height="24" alt="">
              <div v-if="item.jCSL>0">
                <img src="../../../assets/images/16/warning.png" width="16" height="16" alt="" v-if="item.cWSL!==0">
                <span v-if="item.cWSL!==0">{{ item.cWSL }}</span>
                <img style="margin-left: 10px" src="../../../assets/images/16/airport_count.png" width="16" height="16"
                     alt="">
                <span>{{ item.jCSL }}</span>
              </div>
            </Cell>
          </Tab>
          <Tab title="通用机场" label="">
            <span>总计：{{ CommonCount }}个</span>
            <div v-for="item in CommonList" :key="item.sXMC" style="margin-left: -0.5rem;margin-right: -0.5rem;margin-top: 10px">
              <div class="title-div" style="position: relative">
                <span style="margin-top: 1rem">{{ item.sXMC === null ? '未知城市' : item.sXMC }}</span>
                <span>{{ '（' + item.airportList.length + '个）' }}</span>
                <img v-if="item.sXMC===null" src="../../../assets/images/16/warning.png" width="16" height="16" alt="">
                <img src="../../../assets/images/32/map.png" alt="" width="24" height="24"
                     @click="GoMap(item.airportList)"
                     style="position: absolute;top: 50%;bottom: 50%;margin: auto">
              </div>
              <Cell :title="airport.iATA===null?airport.jCMC:(airport.jCMC+'（'+airport.iATA+'）')"
                    v-for="airport in item.airportList"
                    :key="airport.jCMC+airport.iD" class="cellstyle"
                    v-on:click.native="Go(airport,airport.iD!==0)"
                    :is-link="airport.iD!==0">
                <img v-if="airport.iD===0" src="../../../assets/images/16/warning.png" width="16" height="16" alt=""
                     style="margin-right: 20px">
                <span style="color: #2986de">{{ airport.dJ }}</span>
              </Cell>
            </div>
          </Tab>
          <Tab title="机场地图" label="">
            <BingMap></BingMap>
          </Tab>
        </Tabs>
      </div>
    </div>
  </div>
</template>

<script>
import {Indicator, Cell} from "mint-ui";
import {Tab, Tabs} from "vant";
import BingMap from "@/components/menu/tools/Map/BingMap";

export default {
  name: "Airport",
  components: {
    BingMap,
    Tab, Tabs, Cell
  },
  mounted() {
    this.getAirportByProvince()
    this.getAirportByLevel()
    this.getAirportByRegion()
    this.getAllCommonAirport()
  },
  data() {
    return {
      ProvinceList: [],
      LevelList: [],
      RegionList: [],
      CommonList: [],
      ProvinceCount: 0,
      LevelCount: 0,
      RegionCount: 0,
      CommonCount: 0,
      token: localStorage.getItem('token'),
      getAirportByProvinceUrl: '/api/airport/getAirportByProvince',
      getAirportByLeveleUrl: '/api/airport/getAirportByLevel',
      getAirportByRegionUrl: '/api/airport/getAirportByRegion',
      getAllCommonAirportUrl: '/api/airport/getAllCommonAirport',
    }
  },
  methods: {
    GoMap(airportList) {
      let list = []
      airportList.forEach(x => {
        let item = {title: x.jCMC, data: {jD: x.jD, wD: x.wD, dJ: x.dJ}}
        list.push(item)
      })
      this.$router.push({name: 'm_bing_map', query: {point: list}})
    },
    Go(item, bo) {
      if (bo)
        this.$router.push({path: 'm_airport_details', query: {key_id: item.iD}})
    },
    getAllCommonAirport() {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getAllCommonAirportUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          if (response.data['responseData'].length > 0) {
            that.CommonList = response.data['responseData']
            that.CommonList.forEach(x => {
              that.CommonCount += x.airportList.length
            })
          }
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    getAirportByRegion() {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getAirportByRegionUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          if (response.data['responseData'].length > 0) {
            that.RegionList = response.data['responseData']
            that.RegionList.forEach(x => {
              that.RegionCount += x.jCSL
            })
          }
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    getAirportByProvince() {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getAirportByProvinceUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          if (response.data['responseData'].length > 0) {
            that.ProvinceList = response.data['responseData']
            that.ProvinceList.forEach(x => {
              that.ProvinceCount += x.jCSL
            })
          }
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    getAirportByLevel() {
      Indicator.open({
        text: '加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getAirportByLeveleUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close()
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          if (response.data['responseData'].length > 0) {
            that.LevelList = response.data['responseData']
            that.LevelList.forEach(x => {
              that.LevelCount += x.jCSL
            })
          }
        }
      }).catch(response => {
        Indicator.close()
        this.$messagebox.alert(response.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    GoProvince(item) {
      this.$router.push({path: 'm_airport_list', query: {sXMC: item.sXMC, type: 'province'}})
    },
    GoLevel(item) {
      this.$router.push({path: 'm_airport_list', query: {sXMC: item.sXZ, type: 'level'}})
    },
    GoRegion(item) {
      this.$router.push({path: 'm_airport_list', query: {sXMC: item.sXZ, type: 'region'}})
    },
    Onfocus() {
      let callback = {path: 'm_airport_details', query: null}
      this.$router.push({name: 'm_search', params: {sigle: '1', url: '/api/airport/search', callback: callback}})
    },
  }
}
</script>

<style lang="less" scoped>
.cellstyle {
  text-align: left;
}

.rootDiv {
  margin-top: -0.5rem;
}

.title-div {
  background-color: #8450C5;
  padding-top: 5px;
  padding-bottom: 5px;

  span {
    font-size: 1.4rem;
    color: white;
  }
}
</style>
